import { gql } from "@apollo/client";
import { TICKET_POOL_FRAGMENT } from "ticketPool";

export const TICKET_TEMPLATE_FRAGMENT = gql`
  fragment TicketTemplate on TicketTemplate {
    id
    name
    venueId
    createdAt
    updatedAt
  }
`;

export const TICKET_TEMPLATE_NODE_FRAGMENT = gql`
  ${TICKET_TEMPLATE_FRAGMENT}
  ${TICKET_POOL_FRAGMENT}
  fragment TicketTemplateNode on TicketTemplate {
    ...TicketTemplate
    ticketPools(
      skip: $ticketPoolsSkip
      take: $ticketPoolsTake
      filters: $ticketPoolsFilters
      orderBy: $ticketPoolsOrderBy
    ) @skip(if: $skipTicketPools) {
      count
      nodes {
        ...TicketPool
      }
    }
  }
`;
